import { Divider } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IState } from '../../config/rootReducer';
import LoadingScreen from '../../shared/components/LoadingScreen/LoadingScreen';
import { DispatchAccess } from './action/HomeAccessActions';
import HomeAccessError from './HomeAccessError';
import HomeBody from './HomeBody';
import HomeHeader from './HomeHeader';
import HomeHelp from './HomeHelp';

/**
 * Componente que renderiza los productos que el usuario tiene disponible a través
 * de íconos
 * @returns
 */
const Home = () => {
  const dispatch = useDispatch();
  const error = useSelector((state: IState) => state.home.error);
  const load = useSelector((state: IState) => state.home.load);
  useEffect(() => {
    dispatch(DispatchAccess(true));
  }, []);

  return load ? (
    <LoadingScreen />
  ) : error ? (
    <HomeAccessError />
  ) : (
    <>
      <HomeHeader />
      <HomeBody />
      <Divider />
      <HomeHelp />
    </>
  );
};

export default Home;
